import React, { useEffect, useState } from "react";
import { Radio, RefreshCw } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";

const SOURCES = [
  { key: "banners", url: "/banners", list: "banners", label: "Banners", tab: "banners", text: (x) => x.message },
  { key: "ads", url: "/ads", list: "ads", label: "Advertisements", tab: "ads", text: (x) => x.title },
  { key: "cards", url: "/card-banners", list: "banners", label: "Card Banners", tab: "cardbanners", text: (x) => x.heading },
  { key: "carousel", url: "/carousel", list: "banners", label: "Carousel", tab: "carousel", text: (x) => x.title || "(image only)" },
  { key: "offers", url: "/offers/active", list: "offers", label: "Offers", tab: "offers", text: (x) => x.title },
];

export const LiveAnnouncements = ({ onOpen, isMainAdmin }) => {
  const [data, setData] = useState({});
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(false);
  const load = async () => {
    setLoading(true);
    const out = {};
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
    await Promise.all(SOURCES.map((s) => api.get(s.url).then((r) => { out[s.key] = r.data[s.list] || []; }).catch(() => { out[s.key] = []; })));
    setData(out); setLoading(false);
  };
  useEffect(() => { load(); }, []);
  const msgs = [settings.broadcast_live && settings.broadcast_text && `Broadcast: ${settings.broadcast_text}`, settings.marquee_live && settings.marquee_text && `Scrolling: ${settings.marquee_text}`].filter(Boolean);
  return (
    <div className="bg-card border border-brand-line rounded-2xl p-6" data-testid="live-announcements">
      <div className="flex items-center justify-between gap-3 mb-1">
        <h3 className="font-heading font-semibold text-lg flex items-center gap-2"><Radio className="w-5 h-5 text-brand-terracotta" /> Live on the website now</h3>
        <Button size="sm" variant="outline" className="rounded-full" onClick={load} disabled={loading} data-testid="live-refresh"><RefreshCw className={`w-4 h-4 mr-1 ${loading ? "animate-spin" : ""}`} />Refresh</Button>
      </div>
      <p className="text-sm text-brand-muted mb-4">Exactly what visitors see right now (area-targeted items appear only in that area). Deleted or disabled items disappear from here and from the home page.</p>
      <div className="grid sm:grid-cols-2 gap-3">
        {SOURCES.map((s) => (
          <div key={s.key} className="border border-brand-line rounded-xl p-4" data-testid={`live-${s.key}`}>
            <div className="flex items-center justify-between"><span className="font-semibold text-brand-ink">{s.label}</span><span className="text-xs font-bold px-2 py-0.5 rounded-full bg-brand-emerald/10 text-brand-emerald" data-testid={`live-count-${s.key}`}>{(data[s.key] || []).length} live</span></div>
            <ul className="mt-2 space-y-1 text-sm text-brand-muted">{(data[s.key] || []).slice(0, 4).map((x) => <li key={x.id} className="truncate">• {s.text(x)}</li>)}</ul>
            {(isMainAdmin || !["banners", "ads"].includes(s.tab)) && <button type="button" className="text-xs text-brand-emerald font-semibold mt-2" onClick={() => onOpen(s.tab)} data-testid={`live-manage-${s.key}`}>Manage →</button>}
          </div>
        ))}
        <div className="border border-brand-line rounded-xl p-4" data-testid="live-messages">
          <div className="flex items-center justify-between"><span className="font-semibold text-brand-ink">Messages</span><span className="text-xs font-bold px-2 py-0.5 rounded-full bg-brand-emerald/10 text-brand-emerald">{msgs.length} live</span></div>
          <ul className="mt-2 space-y-1 text-sm text-brand-muted">{msgs.map((m) => <li key={m} className="truncate">• {m}</li>)}</ul>
          {isMainAdmin && <button type="button" className="text-xs text-brand-emerald font-semibold mt-2" onClick={() => onOpen("messages")} data-testid="live-manage-messages">Manage →</button>}
        </div>
      </div>
    </div>
  );
};
